import geoAPI from "../../../api/geoAPI";
import { urlContexts } from "../../../constants";

export const getCountries = async (tenantid: string) => {
    const { data } = await geoAPI.get(
          `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
            (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
            }/iuvibanking-point-service-api/rest/1.0/countries`,
          {
            headers: {
              tenant: tenantid
            }
          }
        );
  
    return data;
};

export const getDepartments = async (tenantid: string) => {
    const { data } = await geoAPI.get(
            `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
            (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
            }/iuvibanking-point-service-api/rest/1.0/states`,
            {
            headers: {
                tenant: tenantid
            }
            }
        );

    return data;
};

export const getCities = async (tenantid: string) => {
    const { data } = await geoAPI.get(
            `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
            (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
            }/iuvibanking-point-service-api/rest/1.0/cities`,
            {
            headers: {
                tenant: tenantid
            }
            }
        );

    return data;
};
